import { createSvgIcon } from "@mui/material";

export const NewspaperIcon = createSvgIcon(
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 283.46 283.46" fill="currentColor">
        <g>
            <path d="M216.59,117.08c0-2.81,0-6.34,0-8.76c-18-18-23.73-23.45-41.73-41.45c-4.05,0-5.71,0.02-9.42,0.02l0,0H87.88
                c-11.58,0-21,9.42-21,21V195.6c0,11.58,9.42,21,21,21h107.71c11.58,0,21-9.42,21-21v-78.5V117.08z M195.59,198.6H87.88
                c-1.63,0-3-1.37-3-3V87.89c0-1.63,1.37-3,3-3h77.56v32.3h33.15v78.41C198.59,197.22,197.21,198.6,195.59,198.6z"/>
            <rect x="98.11" y="98.73" width="42.62" height="18"/>
            <rect x="98.11" y="131.85" width="83.86" height="18"/>
            <rect x="98.11" y="165.21" width="83.86" height="18"/>
        </g>
    </svg>,
    'NewspaperIcon'
)
